import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    icon: {
      fill: palette.primary.contrastText
    }
  };
});

var MenuIcon = function MenuIcon(props) {
  var classes = useStyles();
  return React.createElement(SvgIcon, Object.assign({
    className: classes.icon,
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, props), React.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }));
};

export default MenuIcon;